module.exports = __webpack_public_path__ + "static/media/banner4.93baeade.jpg";